import { createSlice } from '@reduxjs/toolkit';
import initialState from './initial-state';
import cookieUtil from 'tradera-utils/cookie';
import { REGION_PICKER_DISMISSED } from 'tradera-constants/cookies';

const shippingRegionSlice = createSlice({
    name: 'shippingRegion',
    initialState,
    reducers: {
        setShippingCountry: (state, action) => {
            const { countryCodeIso2 } = action.payload;
            state.shippingCountry = { countryCodeIso2 };
        },
        setDefaultShippingCountry: state => {
            // Remove name
            state.shippingCountry = { countryCodeIso2: 'SE' };
        },
        setAvailableShippingCountries: (state, action) => {
            state.availableShippingCountries = action.payload.shippingCountries;
            state.hasLoadedAvailableShippingCountries = true;
            state.isLoadingAvailableShippingCountries = false;
        },
        beginLoadingAvailableShippingOptions: state => {
            state.isLoadingAvailableShippingCountries = true;
        },
        dismissLocalizationRegionPicker: {
            reducer: state => {
                state.localizationRegionPickerEnabled = false;
            },
            prepare: () => {
                cookieUtil.createCookie(REGION_PICKER_DISMISSED, true);
                return {};
            }
        }
    }
});

export const {
    setShippingCountry,
    setAvailableShippingCountries,
    beginLoadingAvailableShippingOptions,
    dismissLocalizationRegionPicker,
    setDefaultShippingCountry
} = shippingRegionSlice.actions;
export default shippingRegionSlice.reducer;
